import {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals/facebook_story';
import {FacebookStory} from '../../../reducers/modals/actions';
import BlueButton from "../../components/blue-button"
import GreenButton from "../../components/blue-button"
import ModalsLib from '../../../lib/modals';
import FormInput from '../../components/form-input';


export default () => {
    const {post, button} = useSelector(Selector),
          [url, setUrl] = useState(''),
          [validator, setValidator] = useState(false),
          dispatch = useDispatch();

    return (
        <div className="modal facebook_share animate__animated animate__fadeInUp animate__faster ">
            <div className="modal-header">
                <div className="modal-header-left">
                    <div className="title">Facebook Story</div>
                    <div className="descriptions">Open the post and add it to story.</div>
                </div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <div className="steps">
                    <div className="step">
                        <span>
                            <b>1.</b>
                        </span>
                        <span>
                            Open the post by clicking on <a target="_blank" href={post.link}>this link</a>
                        </span>
                    </div>
                    <div className="step">
                        <span>
                            <b>2.</b>
                        </span>
                        <span>
                            Add him to your story.
                        </span>
                    </div>
                    <div className="step"> 
                        <span>
                            <b>3.</b>
                        </span>
                        <span>
                            Copy the link to your profile and paste it into the field below.
                        </span>
                    </div>
                </div>

                <div className="modal-message info">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#0C76DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 12.5L11.5 14L14.75 11" stroke="#0C76DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <span>
                        The task will be completed if your profile is public, your posts are publicly visible, your account has at least 30 friends, and your page does not contain any other casino-related content.
                    </span>
                </div>

                <hr/>
                <div className="form-group">
                    <FormInput
                        type={'text'}
                        label={'Link to your profile'}
                        placeholder={'https://facebook.com/...'}
                        defaultValue={''}
                        validators={[
                            (value) => {
                                try {
                                    const url = new URL(value);

                                    if(!['www.facebook.com', 'm.facebook.com', 'facebook.com'].includes(url.hostname))
                                        return false;

                                    return true;
                                } catch(e) {
                                    return false;
                                }
                            }
                        ]}
                        onChange={({value, validator}) => {
                            setUrl(value);
                            setValidator(validator);
                        }} />
                </div>

            </div>

            <div className="modal-footer">
                <BlueButton disabled={!validator} active={button} onClick={e => {
                    dispatch(FacebookStory.send({
                        post_id: post.id,
                        url
                    }));
                }}> 
                    Confirm
                </BlueButton>
                <div className="button close" onClick={e => ModalsLib.close()}>
                    Close
                </div>
            </div>
        </div>
    )
}